import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import Navigation from '@App/navigation'
import DotsPopover from '@Components/DotsPopover'
import { PermissionActions } from '@App/enum/permission-actions'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'

interface PermissionHeadMenuProps {
    onOpenConfirmPopup: (newActionType: PermissionActions) => void
}

const PermissionHeadMenu = (props: PermissionHeadMenuProps) => {
    const { rightsholderStore } = useContext<RootStore>(StoresContext)
    const { onOpenConfirmPopup } = props

    return (
        <div className="head-menu">
            <Link
                to={Navigation.rightholder.maintenance.userPermissions(rightsholderStore.currentRightsholderId)}
                className="back small black-text bold"
            >{`< Back`}</Link>
            <div className="buttons-block">
                <DotsPopover>
                    <p onClick={() => onOpenConfirmPopup(PermissionActions.resentInvite)}>Resend Invite</p>
                    <p onClick={() => onOpenConfirmPopup(PermissionActions.removeUser)} className="delete">
                        Remove User
                    </p>
                </DotsPopover>
            </div>
        </div>
    )
}

export default observer(PermissionHeadMenu)
